const userAgent = navigator.userAgent.toLowerCase()

export const userAgentInfo = {
  isSafari: userAgent.includes('safari') && !userAgent.includes('chrome'),
  isTouchScreen: window.matchMedia('(pointer: coarse)').matches,
}
